<template>
  <div class="dialog">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <div class="Languagelist">
        <el-form-item label="客户号：" prop="customerId" style="margin: 20px 0">
          <el-select
            v-model="ruleForm.customerId"
            placeholder="请选择客户号"
            filterable
            clearable
            @change="handleCustomerChange"
          >
            <el-option label="ALL" value="ALL"></el-option>
            <el-option
              v-for="(item, index) in customerList"
              :key="index"
              :label="item.cusNo"
              :value="item.cusNo"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="渠道号：" prop="channelId" style="margin: 20px 0">
          <el-select
            v-model="ruleForm.channelId"
            placeholder="请选择渠道号"
            filterable
            clearable
            :disabled="!ruleForm.customerId"
            @change="handleChannelChange"
          >
            <el-option label="ALL" value="ALL"></el-option>
            <el-option
              v-for="(item, index) in channelList"
              :key="index"
              :label="item.channelName"
              :value="item.channelName"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目号：" prop="projectId" style="margin: 20px 0">
          <el-select
            v-model="ruleForm.projectId"
            placeholder="请选择项目号"
            filterable
            clearable
            :disabled="!ruleForm.channelId"
          >
            <el-option label="ALL" value="ALL"></el-option>
            <el-option
              v-for="(item, index) in projectList"
              :key="index"
              :label="item.projectName"
              :value="item.projectName"
            ></el-option>
          </el-select>
        </el-form-item>
      </div>
      <el-form-item label="标题：" prop="title">
        <el-input
          v-model.trim="ruleForm.title"
          placeholder="请输入标题"
          :maxlength="50"
        ></el-input>
      </el-form-item>
      <div class="footerBtn">
        <el-button type="primary" @click="submitForm('ruleForm')"
          >确定</el-button
        >
        <el-button @click="cancelForm('ruleForm')">取消</el-button>
      </div>
    </el-form>
  </div>
</template>
<script>
import PageTable from "@/components/PageTable.vue";
import {
  getScrollWordData,
  addScrollWordData,
  updateDevice,
} from "../../scrollWordManage/api.js";
import { getProJectList } from "@/api/ozBlockConf";
export default {
  components: { PageTable },
  props: {
    AddinterveneData: {
      type: Object,
      default() {
        return {};
      },
    },
    operationType: {
      type: String,
      default() {
        return "";
      },
    },
  },
  data() {
    return {
      dialogVisible: "", //禁用提示框
      recover: false, //恢复使用提示框
      ruleForm: { title: "", customerId: "", channelId: "", projectId: "" }, //表单数据
      customerList: [],
      channelList: [],
      projectList: [],
      rules: {
        customerId: [
          { required: true, message: "请选择客户号", trigger: "change" },
        ],
        channelId: [
          { required: true, message: "请选择渠道号", trigger: "change" },
        ],
        projectId: [
          { required: true, message: "请选择项目号", trigger: "change" },
        ],
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
      },
    };
  },
  watch: {
    AddinterveneData: {
      async handler(newData) {
        this.ruleForm = {
          title: "",
          customerId: "",
          channelId: "",
          projectId: "",
          ...newData,
        };
        this.channelList = [];
        this.projectList = [];
        this.customerList = await this.getOptions({ type: 1 });
        // 编辑回显时按已有客户号/渠道号加载联动下拉
        if (this.ruleForm.customerId) {
          this.channelList = await this.getOptions({
            cusNo: this.ruleForm.customerId,
            type: 2,
          });
        }
        if (this.ruleForm.customerId && this.ruleForm.channelId) {
          this.projectList = await this.getOptions({
            cusNo: this.ruleForm.customerId,
            channelName: this.ruleForm.channelId,
            type: 3,
          });
        }
        this.$nextTick(() => {
          this.$refs.ruleForm && this.$refs.ruleForm.clearValidate();
        });
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    // 三号联动下拉
    async getOptions(params) {
      const res = await getProJectList(
        { page: 1, size: 3000, ...params },
        false,
      );
      if (res && res.code === 0) {
        return res.data.list || [];
      }
      return [];
    },
    async handleCustomerChange(value) {
      this.ruleForm.channelId = "";
      this.ruleForm.projectId = "";
      this.channelList = [];
      this.projectList = [];
      if (!value) {
        return;
      }
      this.channelList = await this.getOptions({
        cusNo: value,
        type: 2,
      });
    },
    async handleChannelChange(value) {
      this.ruleForm.projectId = "";
      this.projectList = [];
      if (!value || !this.ruleForm.customerId) {
        return;
      }
      this.projectList = await this.getOptions({
        cusNo: this.ruleForm.customerId,
        channelName: value,
        type: 3,
      });
    },
    //禁用
    forbidden() {
      this.dialogVisible = true;
    },
    dialogVisibleBtn() {
      this.$emit("dialogclose", false);
    },
    //禁用确定按钮
    forbiddenBtn() {
      this.$emit("dialogclose", false, this.confirm);
    },
    //恢复
    recoverClose() {
      this.recover = true;
    },
    //恢复确定按钮
    recoverBtn() {
      this.recover = false;
    },
    // 提交按钮
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ruleForm.scene = 2;
          if (this.operationType == "add") {
            addScrollWordData(this.ruleForm).then((res) => {
              if (res && res.code === 0) {
                this.$emit("creadInit", false);
                this.$message.success(res.msg);
              }
            });
          } else if (this.operationType == "edit") {
            updateDevice(this.ruleForm).then((res) => {
              if (res && res.code === 0) {
                this.$emit("creadInit", false);
                this.$message.success(res.msg);
              }
            });
          }
        }
      });
    },
    // 滚动词查询列表
    getScrollWordData(formInline) {
      getScrollWordData(formInline).then((res) => {
        let modelTabelList = {};
        if (res && res.code === 0) {
          modelTabelList.list = res.data.list;
          modelTabelList.total = res.data.total;
          this.$emit("closedialog", false, modelTabelList);
          this.ruleForm = {};
        }
      });
    },
    //取消按钮
    cancelForm(formName) {
      this.$emit("closedialog", false);
      this.$refs[formName].resetFields();
    },
    selectTakeEffect() {
      if (this.ruleForm.takeEffect == 1) {
        this.disabledDate = true;
      } else {
        this.disabledDate = false;
      }
    },
  },
};
</script>
<style scoped lang="scss">
.dialog {
  position: relative;
  padding-bottom: 50px;
  width: 100%;
  .dialogBtn {
    position: absolute;
    bottom: 0;
    right: 0;
  }
  .footerBtn {
    margin-top: 80px;
    display: flex;
    justify-content: flex-end;
  }
  ::v-deep .el-select {
    width: 100%;
  }
  ::v-deep .el-input__inner {
    width: 100%;
  }
}
</style>
